export default __webpack_public_path__ + "static/media/c5.4dbe658b.svg";